import { useSelector } from 'react-redux';
import { Communications } from '../../types/communication';
import useSelectedCommunity from './useSelectedCommunity';
import { RootState } from '../../redux/reducers';

const emptyCommunications: Communications = {
  emails: [],
  notifications: [],
  postcards: [],
};

export default function useCommunications(): Communications | null {
  const selectedCommunity = useSelectedCommunity();
  const communityId = selectedCommunity?.id;

  // Always call useSelector to maintain hook order consistency
  const communications = useSelector((state: RootState) => {
    if (!communityId) return null;
    return state.communications.communications[communityId] ?? emptyCommunications;
  });

  return communications;
}
